var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g({tag:"component",class:_vm.className},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }